// Which Fleet Live panels a viewer shows (#6778, #6779): a PER-VIEWER preference, never
// shared state (brief.md's v2 quirk 4), through the one `localStorage` wrapper
// (`local-pref.ts`) under `fleet-live-vis`, the prototype's own key. Default: every panel
// shown. A stored value that does not parse falls back to the default; a key absent from it
// reads as shown, the prototype's per-key reading (`:3455`), so a value stored before the
// Core joined (`{ deck, topo }`) keeps those two choices and shows the Core.

import { z } from 'zod';
import { readLocalPref, writeLocalPref } from './local-pref';

export const FLEET_LIVE_VIS_KEY = 'fleet-live-vis';

/** The panels, in dock order: Core Intelligence, the Command Deck, the Topology. */
export const FLEET_LIVE_PANELS = ['core', 'deck', 'topo'] as const;
export type FleetLivePanel = (typeof FLEET_LIVE_PANELS)[number];

export type FleetLiveVis = Readonly<Record<FleetLivePanel, boolean>>;

const StoredSchema = z.object({
  core: z.boolean().optional(),
  deck: z.boolean().optional(),
  topo: z.boolean().optional(),
});

export const ALL_SHOWN: FleetLiveVis = { core: true, deck: true, topo: true };

export function readFleetLiveVis(): FleetLiveVis {
  const stored = readLocalPref(FLEET_LIVE_VIS_KEY, StoredSchema, {});
  return { core: stored.core ?? true, deck: stored.deck ?? true, topo: stored.topo ?? true };
}

export function writeFleetLiveVis(vis: FleetLiveVis): void {
  writeLocalPref(FLEET_LIVE_VIS_KEY, vis);
}
